import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=bbdf1dee&"
import script from "./addEdit.vue?vue&type=script&lang=js&"
export * from "./addEdit.vue?vue&type=script&lang=js&"
import style0 from "./addEdit.vue?vue&type=style&index=0&id=bbdf1dee&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports